import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function shortenAddress(address: string, chars = 4): string {
  if (!address) return ''
  return `${address.slice(0, chars + 2)}...${address.slice(-chars)}`
}

export function formatNumber(value: string | number, decimals = 4): string {
  const num = typeof value === 'string' ? parseFloat(value) : value
  if (isNaN(num)) return '0'
  return num.toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: decimals,
  })
}

export function getExplorerUrl(chainId: number, type: 'tx' | 'address', value: string): string {
  const explorers: Record<number, string> = {
    111888: 'https://wer2scan.com',
    56: 'https://bscscan.com',
  }
  const base = explorers[chainId] || explorers[111888]
  // UNI2 explorer uses /uni2/ prefix
  if (chainId === 111888) {
    return `${base}/uni2/${type}/${value}`
  }
  return `${base}/${type}/${value}`
}
